export default "__VITE_ASSET__qCf3JuTx__"